(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const updateCartDOM = (cartData) => {
      // Update Total
      const totalEl = document.querySelector('.cart-total__amount');
      if (totalEl && window.CartAPI) totalEl.textContent = window.CartAPI.formatMoney(cartData.total_price);
      
      // Update individual items
      cartData.items.forEach(item => {
        const itemSubEl = document.querySelector(`.cart-item__subtotal[data-key="${item.key}"]`);
        if (itemSubEl && window.CartAPI) itemSubEl.textContent = window.CartAPI.formatMoney(item.final_line_price);
        
        const inputEl = document.querySelector(`.cart-qty-input[data-key="${item.key}"]`);
        if (inputEl) inputEl.value = item.quantity;
      });

      // Remove DOM elements for items no longer in cart
      const currentKeys = cartData.items.map(item => item.key);
      document.querySelectorAll('.cart-item').forEach(el => {
        const key = el.getAttribute('data-key');
        if (!currentKeys.includes(key)) {
          el.remove();
        }
      });
      
      if (cartData.item_count === 0) {
        window.location.reload();
      }
    };

    const handleQuantityChange = async (key, qty) => {
      if (!window.CartAPI) return;
      try {
        const cartData = await window.CartAPI.change(key, qty);
        updateCartDOM(cartData);
      } catch(err) {
        console.error(err);
      }
    };

    document.querySelectorAll('.qty-minus').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const key = e.target.getAttribute('data-key');
        const input = document.querySelector(`.cart-qty-input[data-key="${key}"]`);
        let newQty = parseInt(input.value) - 1;
        if(newQty < 0) newQty = 0;
        input.value = newQty;
        handleQuantityChange(key, newQty);
      });
    });

    document.querySelectorAll('.qty-plus').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const key = e.target.getAttribute('data-key');
        const input = document.querySelector(`.cart-qty-input[data-key="${key}"]`);
        let newQty = parseInt(input.value) + 1;
        input.value = newQty;
        handleQuantityChange(key, newQty);
      });
    });

    document.querySelectorAll('.cart-qty-input').forEach(input => {
      input.addEventListener('change', (e) => {
        const key = e.target.getAttribute('data-key');
        const newQty = parseInt(e.target.value);
        handleQuantityChange(key, newQty);
      });
    });

    document.querySelectorAll('.cart-remove-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const key = e.target.getAttribute('data-key');
        handleQuantityChange(key, 0);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
